// https://kb.ertelecom.ru/pages/viewpage.action?pageId=429887688
export enum EAccessRights {
    UserGuest = 2 ** 1,
    UserAuth = 2 ** 2,

    PlatformSite = 2 ** 9,

    ConditionZasmotris = 2 ** 25,
}

interface IAccessModeProps {
    rights?: EAccessRights[],
    isAuth?: boolean,
}

export const getAccessModeByRights = ({ rights = [], isAuth }: IAccessModeProps): number => {
    let result = EAccessRights.PlatformSite | rights.reduce((acc, right) => acc + right, 0);

    if (typeof isAuth === 'boolean') {
        if (isAuth) {
            result += EAccessRights.UserAuth;
        } else {
            result += EAccessRights.UserGuest;
        }
    }

    return result;
};
